import BackspaceIcon from '@mui/icons-material/Backspace';
import SearchIcon from '@mui/icons-material/Search';
import {
  Box,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { useContext, useState } from 'react';
import { DoubleDate } from './double-date-picker.interfaces';
import { OrgSettingsContext } from '../../../contexts/org-settings-context';
import { useSnackBar } from '../../../contexts/snackbar';

interface DoubleDatePickerProps {
  dateFilterAction: any;
  headless?: boolean;
  defaultDoubleDate?: DoubleDate;
  disableClear?: boolean;
}
function DoubleDatePicker({
  dateFilterAction,
  headless,
  disableClear = false,
  defaultDoubleDate,
}: DoubleDatePickerProps) {
  const [dateFilter, setDateFilter] = useState<DoubleDate>(
    defaultDoubleDate ?? {
      startDate: null,
      endDate: null,
    }
  );

  const { showMessage } = useSnackBar()

  const { color } = useContext(OrgSettingsContext);

  return (
    <Box>
      {!headless && (
        <legend>
          <b>Date Controls</b>
        </legend>
      )}

      <form>
        <Grid container spacing={1} width={'100%'}>
          <Grid xs={12} md={4}>
            <FormControl fullWidth>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="From"
                  value={dateFilter.startDate}
                  onChange={(newValue) =>
                    setDateFilter({
                      ...dateFilter,
                      startDate: newValue,
                    })
                  }
                />
              </LocalizationProvider>
            </FormControl>
          </Grid>

          <Grid xs={12} md={4}>
            <FormControl fullWidth>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="To"
                  value={dateFilter.endDate}
                  onChange={(newValue) =>
                    setDateFilter({
                      ...dateFilter,
                      endDate: newValue,
                    })
                  }
                />
              </LocalizationProvider>
            </FormControl>
          </Grid>

          <Grid xs={12} md={4}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                height: '100%',
              }}
            >
              <IconButton
                type="submit"
                aria-label="search"
                onClick={(e) => {
                  e.preventDefault();

                  if (dateFilter.startDate != null && !dateFilter.startDate.isValid()) 
                  {
                    showMessage("Invalid start date filter. Please complete the date and try again.", "error")
                    return;
                  }

                  if (dateFilter.endDate != null && !dateFilter.endDate.isValid()) 
                  {
                    showMessage("Invalid end date filter. Please complete the date and try again.", "error")
                    return;
                  }
                  dateFilterAction(dateFilter);
                }}
              >
                <SearchIcon style={{ fill: `${color}` }} />
              </IconButton>

              {!disableClear && (
                <IconButton
                  type="submit"
                  aria-label="search"
                  onClick={(e) => {
                    e.preventDefault();
                    setDateFilter({ startDate: null, endDate: null });
                    dateFilterAction({ startDate: null, endDate: null });
                  }}
                >
                  <BackspaceIcon style={{ fill: `${color}` }} />
                </IconButton>
              )}
            </div>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
}

export default DoubleDatePicker;
